/**
 * Loading Screen – แสดง Lottie sparkles แทน spinner
 * ใช้ใน App (auth loading) และ RequireGoal (goals loading)
 */

import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface LoadingScreenProps {
  /** ข้อความใต้ animation (default: กำลังโหลด...) */
  message?: string;
  /** คลาสเพิ่มเติมสำหรับ wrapper */
  className?: string;
}

export function LoadingScreen({ message = 'กำลังโหลด...', className = '' }: LoadingScreenProps) {
  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center bg-background ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="w-32 h-32 max-w-[40%] aspect-square shrink-0">
        <DotLottieReact
          src="/sparkels.json"
          loop
          autoplay
          className="w-full h-full"
        />
      </div>
      {message && (
        <p className="mt-4 text-muted-foreground text-sm">{message}</p>
      )}
    </div>
  );
}

export default LoadingScreen;
